module.exports = function(app) {
	'use strict';

	app.controller('pages.employee.add.reviewSubmit',
		['$state', '$scope', '$q', '$timeout', 'employee', 'addFlowCommander', 'modal', 'services', 'sessionData', 'coverageBuddy','coremetrics',
		function($state, $scope, $q, $timeout, employee, addFlowCommander, modal, services, sessionData, coverageBuddy,coremetrics) {

			if (!$state.params.subscriberSSN) {
				$state.go('employee.add.subscriber');
				return;
			}

			$scope.commander = addFlowCommander;

            if(sessionData.appConfig && sessionData.appConfig.SEP) {
                $scope.hasSEP = sessionData.appConfig.SEP.booleanValue;
            }
            else {
                $scope.hasSEP = false;
            }
            $scope.outSideOpen = false;
            if($scope.hasSEP) {
                services.eprsvc.lifeEventRules().checkOpenEnrollment().then(
                    function (response) {
						if (response) {
							$scope.outSideOpen = response;
						}
					});
                services.eprsvc.lifeEventRules().getLifeEventRules().then(
                    function (response) {
                        if (response && response.data && response.data.payload) {
                            $scope.lifeEventValues = response.data.payload;
                            if($scope.lifeEventValues) {
                                var newArray = $scope.lifeEventValues.filter(function (el) {
                                    return el.lifeEventId === employee.data.subscriber.eventCode;
                                });
                                $scope.lifeDescription = newArray[0].lifeEventDescription;
                            }
                        }
                    }
                );
            }

			employee.loadEnrollment($state.params.subscriberSSN).then(
				function(employee) {
					$scope.employee = employee;
					$scope.hasProviders = coverageBuddy.hasParticipantsWithProviders(employee.data);
					$scope.reportCodeGroups = coverageBuddy.getReportCodeGroups(employee.data);
					$scope.participantsWithProviders = coverageBuddy.getParticipantsWithProviders(employee.data);
				}
			);

			$scope.expand = {
				subscriberInfo: true,
				dependents: true,
				planCoverage: true,
				otherInsurance: true,
				medicare: true,
				tobacco: true,
				reportCodes: true,
				mnloa: true,
				providers: true,
				lifeEventInfo: true
			};

			$scope.setExpansions = function(open) {
				Object.keys($scope.expand).forEach(function(expansion) {
					$scope.expand[expansion] = open;
				});
			};

			$scope.launchResponseModal = function(response, isSaveForLater) {
				if (isSaveForLater) {
					return;
				}
				if (response && response.data && response.data.payload instanceof Object) {
					var payload = response.data.payload;
					var groupNumbers = Object.keys(payload);

					var allSucceeded = groupNumbers.every(function(g) { return payload[g]; });
					var allFailed = groupNumbers.every(function(g) { return !payload[g]; });

					var onClose = function() {
						$timeout(function() {
							if ($state.current && $state.current.name === 'employee.add.reviewSubmit') {
								$state.go('home');
							}
						}, 10);
					};

					var name = employee.getDisplayName(employee.data.subscriber);

					var modalScope = $scope.$new();
					modalScope.goHome = function() { $state.go('home'); };
					var ubk = sessionData.employerInfo.brandName;
					
					if (allSucceeded) {
						coremetrics.finishConversion('EMPLOYERS:ENROLLMENT:ADD EMPLOYEE','EMPLOYEES ENROLLMENT');
						coremetrics.pageviewTag('EMPLOYEES:ENROLLMENT:ADD EMPLOYEE:REVIEW AND SUBMIT','EMPLOYEES ENROLLMENT');
						modalScope.modalHeading = 'Success';

						if(ubk == '6012'){
							modalScope.modalContent = 'YOU HAVE SUCCESSFULLY ADDED ' + name.toUpperCase() +'.<br>'
									+'<br>'
                                +'PLEASE READ CAREFULLY.'
                                +'I REALIZE THAT ANY ACT, PRACTICE, OR OMISSION I HAVE'
                                +' PERFORMED THAT CONSTITUTES FRAUD OR INTENTIONAL MISREPRESENTATION OF MATERIAL FACT ASKED'
                                +' FOR ON THIS APPLICATION WILL RENDER THE CONTRACT NULL AND VOID OR SUBJECT TO CANCELLATION,'
                                +' RESCISSION, OR TO DISALLOWANCE OF THE PERSON ABOUT WHICH THE FRADULENT ACT, PRACTICE, OMISSION,'
                                +' OR INTENTIONAL MISREPRESENTATION OF MATERIAL FACT OCCURRED.'
								+'I HAVE READ AND UNDERSTAND THE ABOVE ITEMS.'
						} else {
                            modalScope.modalBody = 'You have successfully added ' + name;
						}
					}
					else if (allFailed) {
						modalScope.modalHeading = 'Submitted';
						if(ubk == '6012'){
							modalScope.modalBody =
								'You transaction has been submitted but could not be fully processed at this time. Please allow 48 hours to complete this transaction for '
							     + name;
						}
						else{
							modalScope.modalBody =
								'Your transaction could not be fully processed at this time for ' +
								name + '. Please allow 48 hours for us to complete your transaction';
						}
					}
					else {
						modalScope.modalHeading = 'Partially Submitted';
						if(ubk == '6012'){
							modalScope.modalBody =
								'You transaction has been submitted but could not be fully processed at this time. Please allow 48 hours to complete this transaction for '
								+ name;
						}
						else{
							modalScope.modalBody =
								'Your transaction could not be fully processed at this time for ' +
								name + '. Please allow 48 hours for us to complete your transaction';
						}
					}

					var launchModal = function(disableOnClose) {
						modal.open({
							scope: modalScope,
							template: require('pages/employee/modals/statusOfSave.html'),
							onClose: disableOnClose ? null : onClose,
							classes: "epr-standard-modal large-modal"
						});
					};


					var clientOffersSpending = sessionData.entitlements.clientQualifiers.spendingAccount;
					var isBlackedOut = sessionData.entitlements.clientQualifiers.spendingAccountBlackedOut;

					var paHasSpendingEntitlement =
						sessionData.entitlements.spending.claimsView ||
						sessionData.entitlements.spending.claimsViewNew ||
						sessionData.entitlements.spending.noClaimsView ||
						sessionData.entitlements.spending.spendingAccountAccess;

					var paHasSpendingEntitlementForGroup = function(group) {
						var paEntitlementGroupMapping = sessionData.employerInfo.planAdministratorEntitlements.entitlementToGroupMapping;
						var claimsView = paEntitlementGroupMapping.spendingAccountClaimsView;
						var claimsViewNew = paEntitlementGroupMapping.spendingAccountClaimsViewNew;
						var noClaimsView = paEntitlementGroupMapping.spendingAccountNoClaimsView;
						var alegeusAccess = paEntitlementGroupMapping.spendingAccountAccess;

						if (Array.isArray(claimsView)) {
							if (claimsView.some(function(gn) { return gn == group.groupNumber; })) {
								return true;
							}
						}
						if (Array.isArray(claimsViewNew)) {
							if (claimsViewNew.some(function(gn) { return gn == group.groupNumber; })) {
								return true;
							}
						}
						if (Array.isArray(noClaimsView)) {
							if (noClaimsView.some(function(gn) { return gn == group.groupNumber; })) {
								return true;
							}
						}
						if (Array.isArray(alegeusAccess)) {
							if (alegeusAccess.some(function(gn) { return gn == group.groupNumber; })) {
								return true;
							}
						}
						return false;
					};

					var enrollmentGroupNumbersForWhichPlanAdminCanOfferSpending = function(memberCoverages) {
						return memberCoverages.filter(paHasSpendingEntitlementForGroup).map(function(g) { return g.groupNumber; });
					};

					var canOfferSpending = allSucceeded && clientOffersSpending && !isBlackedOut && paHasSpendingEntitlement;

					var potentialAddSpendingAccountGroupNumbers =
						enrollmentGroupNumbersForWhichPlanAdminCanOfferSpending(employee.data.subscriber.memberCoverages);

					if (canOfferSpending && potentialAddSpendingAccountGroupNumbers.length) {
						employee.metadata.spendingCheckIsRunning = true;

						var employeesSearchCall =
							services.eprsvc.employeesSearch().fetch({ memberId: employee.data.subscriber.ssn });

						var additionalGroupInformationCalls = potentialAddSpendingAccountGroupNumbers.map(function(gn) {
							return services.eprsvc.additionalGroupInformation({ groupNumber: gn }).fetch(services.eprsvc.additionalGroupInformation().getEffectiveDate(gn));
						});

						var employeeAndGroupCalls = [employeesSearchCall].concat(additionalGroupInformationCalls);

						var getGroupsAndSpendingCalls = function(responses) {
							var spendingAccountInformationCalls;
							var groupNumbersWithSpending;
							var umi;

							if (Array.isArray(responses)) {
								var searchResponse = responses.shift();
								umi =
									Array.isArray(searchResponse.employees) &&
									searchResponse.employees[0] &&
									searchResponse.employees[0].umi;

								if (umi) {
									groupNumbersWithSpending = potentialAddSpendingAccountGroupNumbers.filter(function(g, i) {
										var r = responses[i];
										return r && r.data && r.data.payload && r.data.payload.spendingAccount;
									});
									spendingAccountInformationCalls = groupNumbersWithSpending.map(function(gn) {
										return services.eprsvc.spendingAccountInformation({ umi: umi, groupNumber: gn }).fetch();
									});
								}
							}
							return {
								spendingAccountInformationCalls: spendingAccountInformationCalls || [],
								groupNumbersWithSpending: groupNumbersWithSpending || [],
								umi: umi
							};
						};

						var getGroupWithSystemDepositIndicator = function(o) {
							var spendingAccountInformationCalls = o.spendingAccountInformationCalls;
							var groupNumbersWithSpending = o.groupNumbersWithSpending;
							var umi = o.umi;

							if (spendingAccountInformationCalls.length) {
								return $q.all(spendingAccountInformationCalls).then(
									function(responses) {
										var groupNumber;
										// we need to check the client name before process the data
										for (var i = 0; i < responses.length; ++i) {
											var response = responses[i];
											if (
												response &&
												response.data &&
												response.data.payload &&
												response.data.payload.systemDepositIndicator &&
												response.data.payload.systemDepositIndicator.toLowerCase() === 'y' &&
												response.data.payload.spendingAccountLists.length
											) {
												groupNumber = groupNumbersWithSpending[i];
												break;
											}
										}
										return {
											groupNumber: groupNumber,
											umi: umi
										};
									}
								);
							}
						};

						var setModalButton = function(o) {
							if (o.groupNumber & o.umi) {
								modalScope.goToSpending = function() {
									$state.go('assistEmployees.spendingAccounts', { umi: o.umi, groupNumber: o.groupNumber });
								};
								return true;
							}
						};

						$q.all(employeeAndGroupCalls)
							.then(getGroupsAndSpendingCalls)
							.then(getGroupWithSystemDepositIndicator)
							.then(setModalButton)
							.then(launchModal)
							.catch(launchModal)
							.finally(function() { employee.metadata.spendingCheckIsRunning = false; });
					}
					else {
						launchModal();
					}
				}
			};
		}
	]);
};
